import axios from 'axios';

const API_URL = '/api/super-admin';

export const fetchSubscriptionPlans = async () => {
  const { data } = await axios.get(`${API_URL}/subscription-plans`);
  return data;
};

export const fetchBusinessSubscription = async (businessId) => {
  const { data } = await axios.get(`${API_URL}/businesses/${businessId}/subscription`);
  return data.subscription;
};

export const upsertBusinessSubscription = async (businessId, payload) => {
  const { data } = await axios.put(`${API_URL}/businesses/${businessId}/subscription`, payload);
  return data;
};

export const cancelBusinessSubscription = async (businessId) => {
  const { data } = await axios.post(`${API_URL}/businesses/${businessId}/subscription/cancel`);
  return data;
};
